import React from 'react'
import Content from './Content'
import { apiUrl, dappId } from './config'

import './App.css'

const App = () => {
  React.useEffect(() => {
    fetch(`${apiUrl}/dapp.ping/${dappId}`, {
      method: 'POST',
    })
  }, [])
  return (
    <Content />
  )
}
export default App
